import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './Features.module.scss';
import { isNonEmptyArray, preventOrphans } from '../utils/utils';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

const FeaturesSlider = ({ children }) => {
  const { t, i18n } = useTranslation();
  const sliderRef = useRef(null);
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    setFeatures([
      {
        image: require('../../images/suspension2.jpg'),
        name: 'Body Suspension',
        description: t('sus-desc'),
        points: [t('sus-1'), t('sus-2'), t('sus-3')],
      },
      {
        image: require('../../images/piercing2.jpg'),
        name: 'Piercers for piercers',
        description: t('pier-desc'),
        points: [t('pier-1'), t('pier-2'), t('pier-3')],
      },
      // {
      //   image: require("../../images/play-piercing.jpg"),
      //   name: "Play Piercing",
      //   description:
      //     "Odkrywamy znaczenie play piercingu jako formy ekspresji i duchowego przeżycia. Zakorzeniony w tradycjach plemiennych, play piercing łączy rytuał, sztukę i introspekcję, pozwalając na eksplorowanie granic fizyczności oraz emocji.",
      //   points: [
      //     "Odkryj historię play piercingu w kontekście kultur plemiennych i jego rytualne znaczenie.",
      //     "Weź udział w pokazach artystycznych i warsztatach dotyczących tej unikalnej praktyki.",
      //   ],
      // },
    ]);
  }, [t, i18n.language]); // rerun when language changes

  useEffect(() => {
    if (sliderRef.current && isNonEmptyArray(features)) {
      // @ts-ignore
      sliderRef.current?.slickGoTo(0);
    }
  }, [sliderRef, features]);

  var settings = {
    dots: true,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplaySpeed: 4000,
    cssEase: 'linear',
    prevArrow: <FaChevronLeft />,
    nextArrow: <FaChevronRight />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1.7,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 688,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: true,
          infinite: false,
          autoplay: false,
          arrows: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: true,
          arrows: false,
          infinite: true,
        },
      },
    ],
  };

  if (!isNonEmptyArray(features)) {
    return 'loading...';
  }

  return (
    <div className={styles.cardWrapper} style={{ display: 'block' }}>
      <Slider ref={sliderRef} {...settings}>
        {features.map((feature, i) => (
          <div key={i}>
            <div className={styles.inner}>
              <div className={styles.imgWrap}>
                <img
                  src={feature.image}
                  alt='zdjecia profilowe naszych gospodarzy'
                />
              </div>
              <div className={styles.contentWrap}>
                <p className={styles.name}>{feature.name}</p>
                <p className={styles.description}>
                  {preventOrphans(feature.description)}
                </p>
                <div className={styles.pointsWrap}>
                  {feature.points.map((point, i) => (
                    <div key={i} className={styles.point}>
                      <span />
                      <p>{point}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default FeaturesSlider;
